import React from "react";

import { Item, ItemContent, ItemDescription, ItemGroup, ItemTitle } from "../../../probate/components/ui/item";

// One estate item: who it's with, or what it is, over one line saying what kind it is and how we
// know of it
const Asset = ({ name, type, reference, sourceDocument }) => {
  const details = [type, reference, sourceDocument && `from ${sourceDocument}`].filter(Boolean).join(" · ");
  return (
    <Item variant="outline" role="listitem">
      <ItemContent>
        <ItemTitle>{name}</ItemTitle>
        <ItemDescription>{details}</ItemDescription>
      </ItemContent>
    </Item>
  );
};

export const AssetList = ItemGroup;

export default Asset;
